import { render, staticRenderFns } from "./MatchChangeCard.vue?vue&type=template&id=d0e91a0a&scoped=true&"
import script from "./MatchChangeCard.vue?vue&type=script&lang=js&"
export * from "./MatchChangeCard.vue?vue&type=script&lang=js&"
import style0 from "./MatchChangeCard.vue?vue&type=style&index=0&id=d0e91a0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e91a0a",
  null
  
)

export default component.exports